import { v4 } from "uuid";
import { FileActions, FileDropActionTypes, FileState, FileStatus } from "./types";

// Initial state
const initialState: FileState = {
  file: [],
  lastFilename: "",
  sampleDatasetId: 0,
};

function toFileStatus(file: File): FileStatus {
  return {
    id: v4(),
    file,
    loading: false,
    error: null,
    progress: 0,
  };
}

function updateFile(files: FileStatus[], update: Partial<FileStatus>, id: string) {
  return files.map((obj) => {
    if (obj.id === id) {
      return { ...obj, ...update };
    }
    return obj;
  });
}

// The reducer function
export function fileReducer(state = initialState, action: FileActions): FileState {
  switch (action.type) {
    case FileDropActionTypes.FILE_ADD: {
      return {
        ...state,
        file: state.file.concat(action.payload.map(toFileStatus)),
      };
    }
    case FileDropActionTypes.ITER_START: {
      const { id } = action.payload;
      return {
        ...state,
        file: updateFile(state.file, { loading: true, progress: 0 }, id),
      };
    }
    case FileDropActionTypes.ITER_PROGRESS: {
      const { id, progress } = action.payload;
      return {
        ...state,
        file: updateFile(state.file, { loading: true, progress }, id),
      };
    }
    case FileDropActionTypes.ITER_SUCCESS: {
      const { id, fileProperties } = action.payload;
      return {
        ...state,
        lastFilename: fileProperties.fileName,
        file: state.file.filter(({ id: fileId }) => fileId !== id),
      };
    }
    case FileDropActionTypes.ITER_SUCCESS_SAMPLE: {
      return {
        ...state,
        sampleDatasetId: state.sampleDatasetId + 1,
      };
    }
    case FileDropActionTypes.ITER_FAILURE: {
      const { id, msg } = action.payload;
      return {
        ...state,
        file: updateFile(state.file, { loading: false, progress: 100, error: msg }, id),
      };
    }
    case FileDropActionTypes.RESET_STATE: {
      return initialState;
    }
    case FileDropActionTypes.CLEAR_ERROR: {
      return {
        ...state,
        file: state.file.filter(({ error }) => error === null),
      };
    }
    case FileDropActionTypes.CLEAR_FILENAME: {
      return { ...state, lastFilename: "" };
    }
    default: {
      return state;
    }
  }
}
